import LessonPlanItem from '@/models/LessonPlanItem';

type UseLessonItemsSummaryProps = {
  itemsMap: Map<string, LessonPlanItem[]>;
};

const sumTime = (items: LessonPlanItem[]) =>
  items.reduce((total, item) => total + item.time, 0);

const useLessonItemsSummary = ({ itemsMap }: UseLessonItemsSummaryProps) => {
  const getTimeByLessonPlan = (lessonPlanId: number) =>
    sumTime(itemsMap.get(String(lessonPlanId)) ?? []);

  const totalTime = Array.from(itemsMap.values()).reduce(
    (total, items) => total + sumTime(items),
    0,
  );

  return { totalTime, getTimeByLessonPlan };
};

export default useLessonItemsSummary;
